import React, { useState } from "react";
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";
import AccSidebar from "../CommonComponents/Accumulativesidebar";
import MainContent from "./MonazamAccountComponents/MainContent";
import AccmulativeRequestContainer from "../AccumulativeRequest/AccmulativeRequestContainer";
import ReversalAccumulativeRequestContainer from "../ReversalAccumulativeRequest/ReversalAccumulativeRequestContainer";
import ReversalIncomingRequestContainer from "../ReversalIncomingRequest/ReversalIncomingRequestContainer";
import UnclaimedRequestContainer from "../UnclaimedRequest/UnclaimedRequestContainer";
import ExpenseRequestContainer from "../ExpenseRequest/ExpenseRequestContainer";
import { FaBars, FaTimes } from "react-icons/fa";
import RollIdPrompt from "../CommonComponents/RollIdPrompt";
import Tabs from "../CommonComponents/Tabs";
import { ActiveRequestProvider, useActiveRequest } from "../CommonComponents/ActiveRequestContext";

const MonazamAccountContent = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { userType } = useParams();
  const { resetTrigger } = useActiveRequest();
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [reload, setReload] = useState(0);
  const [activeRequest, setActiveRequest] = useState(null);

  useEffect(() => {
    if (location.pathname.includes("/monazamaccount")) {
      setActiveRequest(null);
    }
  }, [location.pathname, resetTrigger]);

  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  const handleRequestToggle = (requestType) => {
    setActiveRequest(requestType);
  };

  useEffect(() => {
    if (!userType || (userType !== "hgo" && userType !== "monazam")) {
      navigate("/");
    }
  }, [userType, navigate]);

  const renderContent = () => {
    switch (activeRequest) {
      case "accumulative":
        return <AccmulativeRequestContainer />;
      case "reversal-accumulative":
        return <ReversalAccumulativeRequestContainer />;
      case "reversal-incoming":
        return <ReversalIncomingRequestContainer />;
      case "unclaimed":
        return <UnclaimedRequestContainer />;
      case "expense":
        return <ExpenseRequestContainer />;
      default:
        return <MainContent userType={userType} />;
    }
  };

  return (
    <div className="dashboard-layout d-flex">
      <AccSidebar
        isOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
        reload={reload}
        setReload={setReload}
        onRequestToggle={handleRequestToggle}
        activeRequest={activeRequest}
      />
      <div className={`main-content ${isSidebarOpen ? "blurred" : ""}`}>
        <div className="d-md-none d-flex align-items-center sidebar-logo-bg py-3 px-1">
          <button className="btn" onClick={toggleSidebar}>
            {isSidebarOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
          </button>
          <img
            src="/assets/logo.png"
            alt="Logo"
            className="img-fluid logo pe-5 logo-height"
          />
        </div>
        <RollIdPrompt />
        <div className="me-3 mt-3">
          <Tabs />
        </div>
        {renderContent()}
      </div>
    </div>
  );
};

const MonazamAccount = () => {
  return (
    <ActiveRequestProvider>
      <MonazamAccountContent />
    </ActiveRequestProvider>
  );
};

export default MonazamAccount;
